<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#om8i08kh2a)">
            <path
                d="M12 8.5c0 .13-.02.26-.08.38-.15.37-.52.62-.92.62H1c-.4 0-.77-.24-.92-.62-.16-.37-.07-.8.22-1.09l4.99-5a.996.996 0 0 1 1.41 0l5 5c.19.19.29.45.29.71H12z"
            />
        </g>
        <defs>
            <clipPath id="om8i08kh2a">
                <path d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>
